import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const deleteUsers = (
  { id, type }
    :
    { id: string, type: 'removeMember' | 'cancelInvitation' }
) => {
  return axiosPrivate.post(`/dashboard/v1/staff_management/${id}/delete_user${type === 'cancelInvitation' ? `?cancel_invite=true` : ''}`);
};